import state from './module-contactadditional-state';
import mutations from './module-contactadditional-mutations';
import actions from './module-contactadditional-actions';
import getters from './module-contactadditional-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
